<template>
  <div class="hello">
    <h2>{{ msg }}</h2>
    <ul>
      <li>
        <a href="https://github.com/huangcong12">GitHub</a>
      </li>
      <li>
        <router-link to='/list'>Blog</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "详情页"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue